import React from 'react';
import PropTypes from 'prop-types';
import BasicModal from './BasicModal';

// Confirmation Modal component for displaying confirmation dialogs
const ConfirmationModal = ({
    isOpen = false,
    title = '',
    hasCancelBtn = true,
    cancelButtonTitle = 'Cancel',
    hasProceedBtn = true,
    proceedButtonTitle = 'Proceed',
    children = {},
    onCancel,
    onProceed,
}) => (
    // Render Confirmation Modal as a Basic Modal with customized content
    <BasicModal isOpen={isOpen} onClose={onCancel}>
        <div className="confirmation-modal">
            {/* Content of the confirmation dialog */}
            <div className="content" style={{ margin: '25px 25px 6px' }}>
                {/* Title of the confirmation dialog */}
                <h1 style={{
                    fontSize: 24,
                    lineHeight: '1px',
                    margin: 0,
                    textAlign: 'center',
                    color: '#000',
                }}>{title}</h1>
                {/* Render children inside the confirmation dialog */}
                {children}
                {/* Action buttons for confirmation dialog */}
                <div className="action-buttons tr flex justify-content-center">
                    {/* Render proceed button if enabled */}
                    {hasProceedBtn && <input type="button" className="btn btn--secondary margin-r-16px " value={proceedButtonTitle} onClick={onProceed} />}
                    {/* Render cancel button if enabled */}
                    {hasCancelBtn && <input type="button" className="btn btn--cancel" value={cancelButtonTitle} onClick={onCancel} />}
                </div>
            </div>
        </div>
    </BasicModal >
);

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    hasCancelBtn: PropTypes.bool,
    cancelButtonTitle: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    children: PropTypes.object,
    hasProceedBtn: PropTypes.bool,
    proceedButtonTitle: PropTypes.string,
    onProceed: PropTypes.func.isRequired,
};

export default ConfirmationModal;
